function getProducts (searchUrls) {

	const endpoint = window.lp.globals.autoComplete.productsUrl;
	return fetch(`${endpoint}/?searchUrls=${encodeURIComponent(JSON.stringify(searchUrls))}`).then((response) =>
		response.json());

}

export default getProducts;
